export default {"src":"/_next/static/image/public/images/ic_search.e999e879584318fe91d733c012e87278.svg","height":18,"width":18};